export default __webpack_public_path__ + "static/media/go_to_market_company_info_preview.5f03a4c3.png";